// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2VThD","productName":"Table_productName__ef63O"};